import React, { Component, useState } from "react";
import { Divider, Typography, Modal, Fab } from "@material-ui/core";
import Skeleton from "react-loading-skeleton";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { 
    getDecks, updateHeaderInfo, confirmCME, getQuizzes, getLongQuizzes, syncCMETest,
    getUserDetails, getDailyQuestion, updateRating, getProgramQuizzes, simulateResponse,
    getFlashCards, getPremadeDecks, getSASPResidencyProgram, getSASPYears, getRanking,
    trackPage
} from "../actions";
import { deviceData, scrollTop, APPVERSION, getThisYear, checkDailyEpoch, remoteURL,createMarkup, testerArr, hasLegal, setLocalStorage, getLocalStorage, OVERLOAD_DATA, setActiveNavigationWidget } from "../common";
import { 
    HomeDeckCard, TestTableCard, TestTabletTableCard, 
    LoadingCard, DailyBannerCard, VersionBannerCard, 
    SaspButton, CopyrightWidget, HomeUserInfo, AILegalStatementCard
} from "../components";
import CloseIcon from '@material-ui/icons/Close';
import CachedIcon from '@material-ui/icons/Cached';
import { 
    isMobileOnly, isTablet, isElectron, deviceDetect, 
    deviceType, isBrowser, isIOS, isAndroid 
} from 'react-device-detect';

import AddIcon from "@material-ui/icons/Add";

import { DATA_TEXT_ARRAY, HOME_TEXT_ARRAY } from "../common";

import { MessageBannerCard } from "../components/MessageBannerCard";
import ModalIcon from "../components/ModalIcon";

class Home extends Component {
    state = {
        cmeYears: [],
        cmeShow: false,
        debug: true,
        cmeTitle: '',
        cmeBody: '',
        cmeProgram: '',
        cmeConfirmed: 0,
        loading: true,
        tracking: null,
        isDaily: 0,
        newVersion: 0,
        hv: 0,
        message: null,
        homeDecks: [],
        premade: [],
        showPre: false,
        _reporting: {
            total: {
                title: "Rank (total)",
                data: [],
                rank: 'N/A'
            },
            weekly: {
                title: "Rank (this week)",
                data: [],
                rank: 'N/A'
            },
            monthly: {
                title: "Rank (this month)",
                data: [],
                rank: 'N/A'
            }
        },
        quizzes: null,
        longquizzes: null,
        programquizzes: null,
        tests: null,
        interval: null,
        loadingtext: 'Please wait while we sync your data.',
        saspyears: null
    };

    handleOpen = () => {
        this.setState({...this.state, cmeShow: true});
    };

    handleClose = () => {
        this.setState({...this.state, cmeShow: false});
    };

    randomtext = () => {
        const arr = HOME_TEXT_ARRAY;
    
        let cnt = 0;
    
        let interval = setInterval(() => {
            // const randomIndex = Math.floor(Math.random() * arr.length);
            let t = arr[cnt];
            this.setState({ ...this.state, loadingtext : t});
            cnt++;
        }, 1500, cnt);
    
        return this.setState({ ...this.state, interval: interval });
    }

    fakeQuestion = async () => {
        for (var i = 0; i < OVERLOAD_DATA.length; i++) {
            setTimeout(() => {
                return this.props.simulateResponse(OVERLOAD_DATA[i]);
            }, 500);
        }

        for (var i = 0; i < OVERLOAD_DATA.length; i++) {
            setTimeout(() => {
                return this.props.simulateResponse(OVERLOAD_DATA[i]);
            }, 500);
        }

        for (var i = 0; i < OVERLOAD_DATA.length; i++) {
            setTimeout(() => {
                return this.props.simulateResponse(OVERLOAD_DATA[i]);
            }, 500);
        }

        return null;
    }

    resetData = async () => {
        await this.setState({ ...this.state, loading: true, loadingtext: this.randomtext() });

        const { mcid, key } = this.props.auth_feedback;
        const { availableyears, isResident, isstaff } = this.props.user_details;
        let pid = mcid;

        if (typeof this.props.residentprogram !== 'undefined' && this.props.residentprogram !== null) {
            pid = this.props.residentprogram.programid
        }

        if (isstaff) {
            // await this.fakeQuestion();

            for (let i = 2012; i <= 2024; i++) {
                let obobj = {
                    mcid: mcid,
                    key: key,
                    programid: mcid,
                    availableyears: availableyears,
                    deckid: 0,
                    sortorder: 1,
                    gamemode: 1,
                    isquiz: 0,
                    year: i
                }

                let cbobj = {
                    mcid: mcid,
                    key: key,
                    programid: mcid,
                    availableyears: availableyears,
                    deckid: 0,
                    sortorder: 1,
                    gamemode: 2,
                    isquiz: 0,
                    year: i
                }

                await this.props.syncCMETest(obobj);
                await this.props.syncCMETest(cbobj);
            }
        }

        const qobj = {
            mcid: mcid,
            key: key,
            programid: pid,
            availableyears: this.props.user_details.authorizedyears
        }

        const pobj = {
            mcid: mcid,
            key: key,
            programid: mcid,
            availableyears: this.props.user_details.authorizedyears
        }

        await this.props.getUserDetails(mcid, key);
        await this.props.getDecks({ mcid: mcid, key: key });
        await this.props.getProgramQuizzes(qobj);
        await this.props.getQuizzes(pobj)
        await this.props.getRanking({ mcid: mcid, key: key, availableyears: this.props.user_details.authorizedyears ? this.props.user_details.authorizedyears: '2012,2013' });
        await this.props.getSASPYears({ mcid: mcid, key: key, availableyears: this.props.user_details.authorizedyears ? this.props.user_details.authorizedyears: '2012,2013' });

        setTimeout(() => {
            return this.setState({ ...this.state, loading: false, loadingtext: 'Please wait while we sync your data.' })
        }, 1500);
    }

    handleScroll = () => {
        if (window.scrollY === 0) {
        }
    }

    componentDidMount = async () => {
        setActiveNavigationWidget("homeFooterIcon");
        window.addEventListener('scroll', this.handleScroll);

        this.randomtext();
        if (getLocalStorage('sasp_my_quizzes', `componentDidMount`) === null) {
            const stringify = {}
            // localStorage.setItem('sasp_my_quizzes', JSON.stringify(stringify))
            setLocalStorage(`sasp_my_quizzes`, JSON.stringify(stringify))
        }

        if (getLocalStorage('sasp_my_cme_tests', `componentDidMount`) === null) {
            var stringify = {}

            for (let i = 2012; i <= 2024; i++ ) {
                let filename = `https://university.auanet.org/json/SASP_TEST_${i}.json`;

                /* if (isBrowser) {
                    filename = `./sasp/json/SASP_TEST_${i}.json`;
                } */

                const obprop = `_${i}_1`;
                const cbprop = `_${i}_2`;

                fetch(filename)
                .then(response => response.json())
                .then(jsonData => {
                    let obobj = jsonData;
                    let cbobj = jsonData;

                    for (const cb of cbobj) {
                        cb.gameMode = 2;
                    }

                    stringify[obprop] = obobj;
                    stringify[cbprop] = cbobj;

                    setLocalStorage(`sasp_my_cme_tests`, JSON.stringify(stringify))
                })
            }
        }

        scrollTop('homeDIV', 0);

        let hv = 0;
        let nv = 0;
        let msg = null
        let isday = this.props.isDaily;
        const { mcid, key } = this.props.auth_feedback;

        if (this.props.user_details.isResident && this.props.residentprogram === null) {
            await this.props.getSASPResidencyProgram({ mcid: mcid, key: key })
        }

        if (this.props.premade.length === 0) {
            this.props.getPremadeDecks({
                mcid: mcid,
                key: key
            })
        }

        const __ls = getLocalStorage('sasp-hideVersion', `componentDidMount`);
        const __msgid = getLocalStorage('sasp-messageid', `componentDidMount`) !== null ? getLocalStorage('sasp-messageid', `componentDidMount`) : 0;
        const __dayid = getLocalStorage('sasp-messageday-id', `componentDidMount`) !== null ? getLocalStorage('sasp-messageday-id', `componentDidMount`) : 0;

        if (typeof __ls !== 'undefined' && __ls !== null) {
            hv = Number(getLocalStorage('sasp-hideVersion', `componentDidMount`));
        } else {
            localStorage.setItem('sasp-hideVersion', 1);
        }

        if (APPVERSION > '1.11.17' && (1 === 1 || testerArr.includes(this.props.auth_feedback.mcid))) {
            if (
                (checkDailyEpoch('sasp-ratingEpoch', 1)) && 
                (isIOS || isAndroid)
            ) {
                if (typeof this.props.user_details.appRated !== 'undefined') {
                    if (!this.props.user_details.appRated) {
                        window.cordova.plugins.AppReview.requestReview().then(function () {
                            let ratingtracking = deviceData(this.props.location, 'rate app');

                            this.props.updateRating({
                                mcid: this.props.auth_feedback.mcid,
                                key: this.props.auth_feedback.key,
                                tracking: ratingtracking
                            });
                        }).catch(function() {
                            this.props.updateRating({
                                mcid: this.props.auth_feedback.mcid,
                                key: this.props.auth_feedback.key,
                            });

                            return window.cordova.plugins.AppReview.openStoreScreen();
                        });
                    }
                } else {
                }
            } else {
            } 
        }

        let loading = true;
        let cmeYears = [];

        let quizzes = null;
        let programquizzes = null;

        await this.props.updateHeaderInfo({route:"/home", iconOne: 'profile'});

        let tracking = deviceData(this.props.location, 'navigate');
        let tobj = {
            mcid: mcid,
            key: key,
            tracking: tracking
        }

        this.props.trackPage(tobj);

        const date = Date.now();
        const ls_user_details = Number(getLocalStorage('sasp_user_DT'))  + (15 * 60 * 1000);
        const ls_decks = Number(getLocalStorage(`sasp_deck_DT`)) + (20 * 60 * 1000);
        
        if (getLocalStorage('sasp_user_details') === null || ls_user_details < date ) {
            await this.props.getUserDetails(mcid, key);
        } else {
            loading = false;
            // cmeYears = this.props.user_details.cmeYears
        }

        if (getLocalStorage(`cmeYears`) !== null) {
            // cmeYears = JSON.parse(getLocalStorage(`cmeYears`));
        }
        
        if (this.props.deckList.length === 0 || ls_decks < date) {
            await this.props.getDecks({ mcid: mcid, key: key });
        }

        if ( typeof this.props.user_details.isstaff !== 'undefined' && this.props.user_details.isstaff && this.props.residentprogram !== null && this.props.programquizzes === null ) {
            const qobj = {
                mcid: mcid,
                key: key,
                programid: this.props.residentprogram.programid,
                availableyears: this.props.user_details.authorizedyears
            }

            await this.props.getProgramQuizzes(qobj)
        } else if ( typeof this.props.user_details.isstaff !== 'undefined' && this.props.user_details.isstaff && this.props.residentprogram !== null && this.props.programquizzes !== null ) {
            programquizzes = this.props.programquizzes

            this.setState({  ...this.state, programquizzes: programquizzes })
        }

        if (this.props.quizzes === null
        ) {
            const pobj = {
                mcid: mcid,
                key: key,
                programid: mcid,
                availableyears: this.props.user_details.authorizedyears
            }

            await this.props.getQuizzes(pobj);
        }  else if ( this.props.quizzes !== null ) {
            await this.setState({ ...this.state, quizzes: this.props.quizzes })
        }

        if (typeof this.props.user_details.appversion !== 'undefined' && !hv) {
            if (isIOS) {
                if (
                    (this.props.user_details.appversion.ios !== APPVERSION && APPVERSION < this.props.user_details.appversion.ios)
                ) {
                    nv = 1;
                }
            } else if (isAndroid) {
                if (this.props.user_details.appversion.android !== APPVERSION && APPVERSION < this.props.user_details.appversion.android) {
                    nv = 1;
                }
            } else if (isElectron) {
                nv = 1;
            }
        }

        if (typeof this.props.user_details.message === 'object') {
            if (typeof this.props.user_details.message.messageid !== 'undefined') {
                if (typeof this.props.user_details.message.messageday !== 'undefined' && typeof this.props.user_details.message.year !== 'undefined') {
                    if (__dayid < this.props.user_details.message.messageday) {
                        msg = this.props.user_details.message;
                    }
                } else if (this.props.user_details.message.messageid > __msgid) {
                    localStorage.setItem('sasp-messageid', this.props.user_details.message.messageid)
                    msg = this.props.user_details.message;
                    hv = 0;
                    nv= 0;
                    isday = 0;
                }
            }
        }

        if (this.props.isDaily) {
            await this.props.getDailyQuestion({
                mcid: this.props.auth_feedback.mcid,
                key: this.props.auth_feedback.key,
                availableyears: this.props.user_details.authorizedyears ? this.props.user_details.authorizedyears: '2012,2013'
            });
        }

        let testarr = null;

        await this.props.getRanking({ mcid: mcid, key: key, availableyears: this.props.user_details.authorizedyears ? this.props.user_details.authorizedyears: '2012,2013' });

        if (typeof this.props.user_details.availableyears === 'string') {
            const ayarr = this.props.user_details.availableyears.split(',');

            testarr = [];

            ayarr.forEach(item => {
                // let prefix = `_${item}_TEST`
                let str = getLocalStorage(`sasp_my_cme_tests`, `componentDidMount`);

                if (str !== null) { str = JSON.parse(str) }

                let obj1 = {id: `_${item}_1`, deckname: `SASP CME Test: ${item}`, year: Number(item), deckid: 0, totalQuestions: 150, gamemode: 1, answered: 0, text: `Start`};

                if (typeof str === 'object') {
                    try {
                        let f1 = str[`_${item}_1`];

                        if (typeof f1 !== 'undefined') {

                        } else {
                        }
                    } catch (e) {
                    }
                }

                testarr = [ ...testarr, obj1 ];

                let obj2 = {id: `_${item}_2`, deckname: `SASP CME Test: ${item}`, year: Number(item), deckid: 0, totalQuestions: 150, gamemode: 2, answered: 0, text: `Start`} 

                testarr = [ ...testarr, obj2 ];
            });

            setLocalStorage('sasp_cme_tests', JSON.stringify(testarr));
        }

        let homeDecks = this.props.deckList.filter((item) => {
            return (item.isHome === 1 && item.totalQuestions > 0) 
        });

        let saspyears = null;

        let _state = { 
            ...this.state, 
            newVersion: nv, 
            hv: hv, 
            isDaily: isday, 
            message: msg,
            tracking: deviceData(this.props.location, 'navigate'),
            homeDecks: homeDecks,
            premade: this.props.premade ? this.props.premade : [],
            showPre: this.props.premade.length === 0 ? false : true,
            tests: testarr,
            loading: loading,
            cmeYears: cmeYears,
            // quizzes: quizzes
            // saspyears: saspyears
        };

        await this.props.getSASPYears({ mcid: mcid, key: key, availableyears: this.props.user_details.authorizedyears ? this.props.user_details.authorizedyears: '2012,2013' });

        return this.setState(_state)
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.saspyears !== this.props.saspyears && this.props.saspyears !== null) {
            return this.setState({ ...this.state, saspyears: this.props.saspyears})
        }

        if (prevState.saspyears !== this.state.saspyears ) {
            if (prevState.saspyears !== null && this.state.saspyears === null) {
                return this.setState({ ...this.state, saspyears: prevState.saspyears, loading: false })
            }
        }

        if (prevProps.appreporting !== this.props.appreporting) {
            return this.setState({ ...this.state, _reporting: this.props.appreporting })
        }

        if (prevProps.quizzes !== this.props.quizzes) {
            return this.setState({ ...this.state, quizzes: this.props.quizzes});
        }

        if (prevProps.longquizzes !== this.props.longquizzes) {
            return this.setState({ ...this.state, longquizzes: this.props.longquizzes});
        }

        if (prevProps.programquizzes !== this.props.programquizzes) {
            return this.setState({ ...this.state, programquizzes: this.props.programquizzes});
        }

        if (prevProps.residentprogram !== this.props.residentprogram) {
        }

        if (prevState.quizzes !== this.state.quizzes) {
            if (this.state.quizzes === null && prevState.quizzes !== null) {
                return this.setState({ ...this.state, quizzes: prevState.quizzes});
            }
        }

        if (prevState.longquizzes !== this.state.longquizzes) {
            if (this.state.longquizzes === null && prevState.longquizzes !== null) {
                return this.setState({ ...this.state, longquizzes: prevState.longquizzes});
            }
        }

        if (prevState.programquizzes !== this.state.programquizzes) {
            if (this.state.programquizzes === null && prevState.programquizzes !== null) {
                return this.setState({ ...this.state, programquizzes: prevState.programquizzes});
            }
        }

        if (prevProps.user_details.cmeYears != this.props.user_details.cmeYears) {
            return null;
            // return this.setState({ ...this.state, cmeYears: this.props.user_details.cmeYears });
        }

        if (prevProps.deckList !== this.props.deckList) {
            const homeDecks = this.props.deckList.filter((item) => {
                return (item.isHome === 1 && item.totalQuestions > 0) 
            });

            return this.setState({
                ...this.state,
                homeDecks: homeDecks
            })
        }

        if (prevProps.user_details != this.props.user_details) {
            if (typeof this.props.user_details.message === 'object') {
                if (typeof this.props.user_details.message.messageid !== 'undefined') {
                    const __msgid = getLocalStorage('sasp-messageid', `prevProps.user_details != this.props.user_details`) !== null ? getLocalStorage('sasp-messageid', `prevProps.user_details != this.props.user_details`) : 0;

                    if (this.props.user_details.message.messageid > __msgid) {
                        localStorage.setItem('sasp-messageid', this.props.user_details.message.messageid);

                        clearInterval(this.state.interval);

                        await this.setState({
                            ...this.state,
                            message: this.props.user_details.message,
                            newVersion: 0,
                            isDaily: 0,
                            hv: 0
                        }) 
                    }
                }
            }

            return this.props.getDailyQuestion({
                mcid: this.props.auth_feedback.mcid,
                key: this.props.auth_feedback.key
            });
        }

        if (prevProps.isDaily != this.props.isDaily) {
            return this.setState({ ...this.state, isDaily: this.props.isDaily})
        }

        if ( prevState.cmeYears != this.state.cmeYears ) {
            return null;

            await this.checkCME();
            this.setState({ ...this.state, loading: false });
        }

        if (prevState.cmeProgram != this.state.cmeProgram) {
            this.handleOpen();
        }

        if (prevProps.premade !== this.props.premade) {
            return this.setState({
                ...this.state,
                premade: this.props.premade
            })
        }

        if (prevState.premade !== this.state.premade) {
            return this.setState({
                ...this.state,
                showPre: true
            })
        }

        if (prevState.homeDecks !== this.state.homeDecks) {
        }

        if (prevState.tests !== this.state.tests) {
            return null
        }
    }

    componentWillUnmount = () => {
        return window.removeEventListener('scroll', this.handleScroll);
    }

    checkCME = async () => {
        return null;

        if (typeof this.state.cmeYears !== 'undefined') {
            let arr = this.state.cmeYears.slice();
            for (let i = 0; i < arr.length; i++) {
                let condition = true;
                if (Number(arr[i].confirmed) > 0 ) { condition = false }
                
                if ( condition ) {
                    let temp = '<p className="margin-bottom-24">There was an error.</p><p className="margin-top-48 margin-bottom-24">Please try again later.</p>';
                    if (typeof arr[i].CMEContent !== 'undefined') {
                        temp = arr[i].CMEContent;
                    }

                    await this.setState({ ...this.state, cmeTitle: "Confirm CME", cmeProgram: arr[i].programID, cmeBody: temp });

                    this.handleOpen();
                    break;
                }
            }
        }
    }

    mapPremadeDecks = () => {
        const path = './static/media/icons/';
        const premade = this.props.premade.filter((item) => {
            return (item.totalQuestions > 0) 
        });

        if (typeof premade !== 'undefined' && premade.length > 0) {
            return premade.map((deck, index) => {
                let _img = index % 50;
                let _path = path + _img + '.png';

                let obj = {
                    deckID: deck.deckID,
                    gameMode: 7,
                    gamemode: 7,
                    deckname: deck.deckname,
                    abbr: deck.abbr ? deck.abbr : 'TMP',
                    subtext: deck.subtext ? deck.subtext : 'xyz questions'
                }

                let __uri = deck.flashcard ? "/showFlashCard" : "/questionScreen";
                let _obj = {
                    pathname: __uri,
                    gameMode: 7,
                    gamemode: 7,
                    deckID: deck.deckID,
                    deckid: deck.deckID
                }

                return(
                    <Link 
                        to={_obj}
                    >
                        <div className="aua-circle-widget">
                            <div className="aua-circle-widget-icon" style={{
                                backgroundImage: `url(${_path})`,
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                padding: "4px"
                                
                            }}>
                                <div style={{fontSize: "0.7em"}}>{obj.deckname}</div>
                                <div className="text-legal margin-bottom-4 hidden" style={{fontSize: "0.7em"}}>{obj.abbr}</div>                            
                            </div>
                            <div className="aua-circle-widget-text">{obj.subtext}</div>
                        </div>
                    </Link>
                )
            })
        } else {
            return null
        }

    }

    mapDecksWidgets = () => {
        const decks = this.props.deckList.filter((item) => {
            return (item.totalQuestions > 0) 
        });

        if (typeof decks !== 'undefined' && decks.length > 0) {
            return decks.map((deck, index) => {
                let obj = {
                    deckID: deck.deckID,
                    gameMode: deck.gameMode,
                    gamemode: deck.gamemode,
                    deckname: deck.deckname,
                    abbr: deck.abbr ? deck.abbr : 'TMP'
                }

                let __uri = deck.flashCards ? "/showFlashCard" : "/questionScreen";
                let _obj = {
                    pathname: __uri,
                    gameMode: deck.gameMode,
                    gamemode: deck.gamemode,
                    deckID: deck.deckID,
                    deckid: deck.deckID
                }

                obj.abbr = `${deck.totalQuestions} questions`;                

                return(
                    <Link 
                        to={_obj}
                    >
                        <div className="aua-circle-widget ">
                            <div className="aua-circle-widget-icon  deck-icon ">
                                {obj.gameMode === 3
                                    ? (
                                        <div className="margin-bottom-4">Open Book</div>
                                    ) : (
                                        <div className="margin-bottom-4">Closed Book</div>
                                    )
                                }

                                <div style={{fontSize: "0.7em"}}>{obj.abbr}</div>
                            </div>
                            <div className="aua-circle-widget-text">{obj.deckname}</div>
                        </div>
                    </Link>
                )
            })
        } else {
            return null
        }

    }

    mapQuizzes = (obj, data, mode) => {
        const quizzes = data.filter((item) => {
            return (item.ispublic > 0 && item.gamemode === mode) 
        });

        if (typeof quizzes !== 'undefined' && quizzes.length > 0) {
            return quizzes.map((quiz, index) => {

                let bgcolor = 'var(--aua-app-background-grad-linear-med-light-green)';
                let color = 'white';

                let obj = {
                    deckID: quiz.deckID,
                    gameMode: quiz.gameMode ? Number(quiz.gameMode) : Number(quiz.gamemode),
                    gamemode: quiz.gamemode ? Number(quiz.gamemode) : Number(quiz.gameMode),
                    deckname: quiz.deckname,
                    abbr: quiz.abbr ? quiz.abbr : 'TMP'
                }

                let __uri = "/quizScreen";
                let _obj = {
                    pathname: __uri,
                    gameMode: quiz.gameMode ? Number(quiz.gameMode) : Number(quiz.gamemode),
                    gamemode: quiz.gamemode ? Number(quiz.gamemode) : Number(quiz.gameMode),
                    deckID: quiz.deckID,
                    deckid: quiz.deckID
                }

                obj.abbr = `${quiz.totalQuestions} questions`;     
                
                if (obj.gamemode === 9 || obj.gamemode === 11) {
                    bgcolor = 'var(--aua-app-background-grad-linear-med-light-blue)';
                } else if (obj.gamemode === 10 || obj.gamemode === 12) {
                    bgcolor = 'var(--aua-app-background-grad-linear-med-light-green)';
                }

                return(
                    <Link 
                        to={_obj}
                    >
                        <div className="aua-circle-widget ">
                            <div 
                                className="aua-circle-widget-icon quiz-icon "
                                style={{background: `${bgcolor}`, color: `${color}`}}
                            >
                                {obj.deckname}

                                <div className="margin-top-4 hidden" style={{fontSize: "0.9em"}}>
                                    {obj.abbr}
                                </div>
                            </div>
                            <div className="aua-circle-widget-text">
                                {obj.gamemode === 9 || obj.gamemode === 11
                                    ? (
                                        <div className="margin-bottom-4">Open Book</div>
                                    ) : (
                                        <div className="margin-bottom-4">Closed Book</div>
                                    )
                                }
                            </div>
                        </div>
                    </Link>
                )
            })
        } else {
            if (typeof obj.name === 'undefined') {
                obj.name = 'Loading...';
            }
    
            if (typeof obj.abbr === 'undefined') {
                obj.abbr = '';
            }
    
            if (typeof obj.deckname === 'undefined') {
                obj.deckname = 'Loading Data';
            }
            return (
                <div className="aua-circle-widget ">
                    <div className="aua-circle-widget-icon  quiz-icon">
                        <div className="margin-bottom-4">{obj.name}</div>
                        <div style={{fontSize: "0.7em"}}>{obj.abbr}</div>
                    </div>
                    <div className="aua-circle-widget-text">{obj.deckname}</div>
                </div>
            )
        }
    }

    mapTests = (obj, data, mode) => {
        const quizzes = data.filter((item, index) => {
            return (Number(item.gamemode) === Number(mode)) 
        });

        if (typeof quizzes !== 'undefined' && quizzes.length > 0) {
            return quizzes.map((quiz, index) => {
                let bgcolor = 'var(--aua-app-background-grad-linear-dark-green)';
                let color = 'white';

                let obj = {
                    deckID: 0,
                    gameMode: quiz.gameMode ? Number(quiz.gameMode) : Number(quiz.gamemode),
                    gamemode: quiz.gamemode ? Number(quiz.gamemode) : Number(quiz.gameMode),
                    year: quiz.year,
                    deckname: quiz.deckname,
                    abbr: quiz.abbr ? quiz.abbr : 'TMP',
                    per: 0
                }

                let __uri = "/quizScreen";
                let _obj = {
                    pathname: __uri,
                    gameMode: quiz.gameMode ? Number(quiz.gameMode) : Number(quiz.gamemode),
                    gamemode: quiz.gamemode ? Number(quiz.gamemode) : Number(quiz.gameMode),
                    deckID: 0,
                    deckid: 0,
                    testYear: quiz.year,
                }    
                
                if (obj.gamemode === 1) {
                    bgcolor = 'var(--aua-app-background-grad-linear-blue)';
                    obj.abbr = `Open Book`; 
                } else {
                    obj.abbr = 'Closed Book'
                }
                
                color = `--aua-app-theme-color`;

                return(
                    <Link 
                        to={_obj}
                    >
                        <div className="aua-circle-widget ">
                            <div 
                                className="aua-circle-widget-icon quiz-icon "
                                style={{background: `white`, color: `${color}`}}
                            >
                                {obj.deckname}

                                <div className="margin-top-4 hidden" style={{fontSize: "0.9em"}}>
                                    {obj.abbr}
                                </div>

                                <>
                                    {obj.per < 100
                                        ? (
                                            <div className="aua-masking-widget" style={{height: `${obj.per}%`, background: `${bgcolor}`}}> </div>
                                        ) : null
                                    }
                                </>
                            </div>

                            <div className="aua-circle-widget-text">
                                {obj.gamemode === 1
                                    ? (
                                        <div className="margin-bottom-4">Open Book</div>
                                    ) : (
                                        <div className="margin-bottom-4">Closed Book</div>
                                    )
                                }
                            </div>
                        </div>
                    </Link>
                )
            })
        } else {
            if (typeof obj.name === 'undefined') {
                obj.name = 'Loading...';
            }
    
            if (typeof obj.abbr === 'undefined') {
                obj.abbr = '';
            }
    
            if (typeof obj.deckname === 'undefined') {
                obj.deckname = 'Loading Data';
            }
            return (
                <div className="aua-circle-widget ">
                    <div className="aua-circle-widget-icon  quiz-icon">
                        <div className="margin-bottom-4">{obj.name}</div>
                        <div style={{fontSize: "0.7em"}}>{obj.abbr}</div>
                    </div>
                    <div className="aua-circle-widget-text">{obj.deckname}</div>
                </div>
            )
        }
    }

    mapLoading = (obj) => {
        if (typeof obj.name === 'undefined') {
            obj.name = 'Loading...';
        }

        if (typeof obj.abbr === 'undefined') {
            obj.abbr = '';
        }

        if (typeof obj.deckname === 'undefined') {
            obj.deckname = 'Loading Data';
        }
        return (
            <div className="aua-circle-widget loading-card-widget">
                <div className="aua-circle-widget-icon  deck-icon">
                    <div className="margin-bottom-4">{obj.name}</div>
                    <div style={{fontSize: "0.7em"}}>{obj.abbr}</div>
                </div>
                <div className="aua-circle-widget-text">{obj.deckname}</div>
            </div>
        )
    }

    mapYearWidgets = (_data, _gamemode) => {
        try {
            const { data, gamemode } = _data;
            const localyears = JSON.parse(getLocalStorage(`sasp_my_cme_tests`));

            if (typeof data !== 'undefined' && data !== null) {
                return data.map((year, index) => {
                    const objprefix = `_${year.ProductYear}_${gamemode}`;
                    const yearobj = localyears[objprefix];

                    /*
                        if (gamemode === 1) {
                            try {
                                year.openpercentage = yearobj[0].percompleted; 
                                year.OpenAnswered = yearobj[0].startindex; 
                            } catch (e) {
                            }
                            
                        } else if (gamemode === 2) {
                            try {
                                year.closedpercentage = yearobj[0].percompleted; 
                                year.ClosedAnswered = yearobj[0].startindex; 
                            } catch (e) {
                            }
                        }
                    */

                    let oPer = Number(year.openpercentage) ? Math.round(Number(year.openpercentage)) : 0;
                    let cPer = Number(year.closedpercentage) ? Math.round(Number(year.closedpercentage)) : 0;

                    if (oPer > 100) { oPer = 100; }
                    else if (year.openpercentage > 0 && year.openpercentage < 1) {
                        oPer = 1;
                    }

                    if (cPer > 100) { cPer = 100; }
                    else if (year.closedpercentage > 0 && year.closedpercentage < 1) {
                        cPer = 1;
                    }
                    
                    let openText = ( oPer != 100 ) ? "Resume" : "Details";
                    let closeText = ( cPer != 100 ) ? "Resume" : "Details";

                    if (oPer === 0) openText = 'Start'
                    if (cPer === 0) closeText = 'Start'

                    let obLink = {
                        pathname : oPer < 100 ? '/questionScreen' : '/testResultScreen',
                        // pathname : oPer < 100 ? '/quizScreen' : '/quizScreen',
                        testYear : year.ProductYear,
                        gameMode : 1,
                        deckID : 0,
                        gamemode: 1,
                        deckid: 0,
                        startindex: year.OpenAnswered, 
                        complete: oPer < 100 ? 0 : 1
                    }

                    let cbLink = {
                        pathname : cPer < 100 ? '/questionScreen' : '/testResultScreen',
                        // pathname : cPer < 100 ? '/quizScreen' : '/quizScreen',
                        testYear : year.ProductYear,
                        gameMode : 2,
                        deckID : 0,
                        gamemode: 2,
                        deckid: 0,
                        startindex: year.ClosedAnswered, 
                        complete: cPer < 100 ? 0 : 1
                    }
        
                    if (oPer >= 100) {
                        obLink.deckID = 0;
                        oPer = 100;
                    }
        
                    if (cPer >= 100) {
                        cbLink.deckID = 0;
                        cPer = 100;
                    }

                    const obj = {
                        abbr: year.ProductYear,
                        deckname: gamemode === 1 ? openText : closeText,
                        per: gamemode === 1 ? oPer : cPer,
                        gamemode: gamemode
                    }

                    let _obj = gamemode === 1 ? obLink : cbLink;
                    let optclass = gamemode === 1 ? 'openbook-icon' : 'closedbook-icon';

                    if (obj.per === 100) {
                        optclass += ' completed-icon';
                    } else if (obj.per === 0) {
                        optclass += ' unstarted';
                        obj.deckname = 'Start'
                    } 

                    if (year.useravailable === 1) {                    
                        return (
                            <Link 
                                to={_obj}
                                onClick={() => {
                                }}
                            >
                                <div className="aua-circle-widget">
                                    <div 
                                        className={`aua-circle-widget-icon ${optclass}`} 
                                    >
                                        <div className="margin-bottom-4">{obj.deckname}</div>
                                        <div className="text-legal">({obj.per}%)</div>
                                        <>
                                            {obj.per < 100
                                                ? (
                                                    <div className="aua-masking-widget" style={{height: `${obj.per}%`}}> </div>
                                                ) : null
                                            }
                                        </>
                                    </div>
                                    <div className="aua-circle-widget-text" style={{fontSize: "1.15em"}} >{obj.abbr}</div>
                                </div>
                            </Link>
                        );
                    } else {
                        let optClass2 = `aua-circle-widget-icon disabled anchor `;
                        optClass2 += gamemode === 1 ? 'openbook-icon' : 'closedbook-icon'

                        return (
                            <div 
                                className="aua-circle-widget"
                                onClick={() => {
                                }}
                            >
                                <div 
                                    className={`${optClass2}`}
                                >
                                    {/* <div className="widget-label-text">Access Denied</div> */}
                                    <div className="widget-label-text">Purchase this year online.</div>
                                </div>
                                <div className="aua-circle-widget-text" style={{fontSize: "1.15em"}} >{obj.abbr}</div>
                            </div>
                        );
                    }
                });
            } else {
                return (
                    <div 
                        className="aua-circle-widget"
                        onClick={() => {
                            return remoteURL('https://university.auanet.org/sasp/public')
                        }}
                    >
                        <div className={`aua-circle-widget-icon error-icon`}>
                            <div className="margin-bottom-4">No Tests Available</div>
                        </div>
                        <div className="aua-circle-widget-text" style={{fontSize: "1.15em"}} >View Online</div>
                    </div>
                );
            }
        } catch (e) {
            return (
                <div 
                    className="aua-circle-widget"
                    onClick={() => {
                        return remoteURL('https://university.auanet.org/sasp/public')
                    }}
                >
                    <div className={`aua-circle-widget-icon error-icon`}>
                        <div className="margin-bottom-4">Error Loading Tests</div>
                    </div>
                    <div className="aua-circle-widget-text" style={{fontSize: "1.15em"}} >View Online</div>
                </div>
            );
        }
    }

    mapHomeDeckCards = () => {
        let cnt = 0;
        const homeDecks = this.state.homeDecks;

        if ( (typeof homeDecks !== 'undefined' && homeDecks.length > 0) ) {    
            return homeDecks.map((deck, index) => {
                let name =
                    index === homeDecks.length - 1
                        ? "lastHomeDeckCardDiv"
                        : "homeDeckCardDiv";
                if (homeDecks.length === 0) {
                    return (
                        <div className={name}>
                            <HomeDeckCard
                                textColor="neutralGreenText"
                                deckColor="neutralGreenCard"
                                buttonColor="neutralGreenCard"
                                index={index}
                                totalLength={homeDecks.length}
                                deckName={deck.deckname}
                                deckID={deck.deckID}
                                totalQs={deck.totalQuestions}
                                gamemode={deck.gameMode}
                            />
                        </div>
                    );
                }
                if (index === 0) {

                    // if (!deck.totalQs) {
                    //     return null
                    // } else {
                    //     cnt++;
                    // }

                    return (
                        <>
                            <div className={name}>
                                <HomeDeckCard
                                    textColor="neutralGreenText"
                                    deckColor="neutralGreenCard"
                                    buttonColor="neutralGreenCard"
                                    index={-1}
                                    totalLength={homeDecks.length}
                                    deckName={deck.deckname}
                                    deckID={deck.deckID}
                                    totalQs={deck.totalQuestions}
                                    gamemode={deck.gameMode}
                                />
                            </div>
                            <div className={name}>
                                <HomeDeckCard
                                    textColor="neutralGreenText"
                                    deckColor="neutralGreenCard"
                                    buttonColor="neutralGreenCard"
                                    index={index}
                                    totalLength={homeDecks.length}
                                    deckName={deck.deckname}
                                    deckID={deck.deckID}
                                    flashcard={deck.flashCards}
                                    totalQs={deck.totalQuestions}
                                    gamemode={deck.gameMode}
                                />
                            </div>
                        </>
                    );
                } else {
                    // if (!deck.totalQs) {
                    //     return null
                    // } else {
                    //     cnt++;
                    // }

                    return (
                        <div className={name}>
                            <HomeDeckCard
                                textColor="neutralGreenText"
                                deckColor="neutralGreenCard"
                                buttonColor="neutralGreenCard"
                                index={index}
                                totalLength={homeDecks.length}
                                deckName={deck.deckname}
                                deckID={deck.deckID}
                                flashcard={deck.flashCards}
                                totalQs={deck.totalQuestions}
                                gamemode={deck.gameMode}
                            />
                        </div>
                    );
                }
            });
        } else {
            return null;
        }
    };

    mapTableCards = props => {
        if (props.user_details != '') {
            return props.saspyears.map(year => {
                let oPer = Number(year.openpercentage) ? Math.round(Number(year.openpercentage)) : 0;
                let cPer = Number(year.closedpercentage) ? Math.round(Number(year.closedpercentage)) : 0;

                if (oPer > 100) { oPer = 100; }
                else if (year.openpercentage > 0 && year.openpercentage < 1) {
                    oPer = 1;
                }
                if (cPer > 100) { cPer = 100; }
                else if (year.closedpercentage > 0 && year.closedpercentage < 1) {
                    cPer = 1;
                }
                /*TODO get what question we are on and determine if we are to resumse or restart*/
                const openText = ( oPer != 100 ) ? "RESUME" : "DETAILS";
                const closeText = ( cPer != 100 ) ? "RESUME" : "DETAILS";

                if (year.useravailable == 1) {                    
                    return (
                        <TestTableCard
                            className="tableCard"
                            useravailable={year.useravailable}
                            testYear={year.ProductYear}
                            openProgress={oPer > 0 ? openText : "BEGIN"}
                            closedProgress={cPer > 0 ? closeText : "BEGIN"}
                            openpercentage={oPer}
                            closedpercentage={cPer}
                        />
                    );
                } else {
                    return (
                        <TestTableCard
                            className="disabledTableCard"
                            useravailable={year.useravailable}
                            testYear={year.ProductYear}
                            openProgress={year.openpercentage > 0 ? openText : "BEGIN"}
                            closedProgress={year.closedpercentage > 0 ? closeText : "BEGIN"}
                        />
                    );
                }
            });
        } else {
            {
                /*Clean and size this up correctly */
            }
            return (
                <div className="homeDeckCardDiv">
                    <Skeleton width={"8em"} height={"11em"} />
                </div>
            );
        }
    };

    mapTabletTableCards = props => {
        if (props.user_details != '') {
            return props.saspyears.map(year => {
                let oPer = Number(year.openpercentage) ? Math.round(Number(year.openpercentage)) : 0;
                let cPer = Number(year.closedpercentage) ? Math.round(Number(year.closedpercentage)) : 0;

                if (oPer > 100) { oPer = 100; }
                else if (year.openpercentage > 0 && year.openpercentage < 1) {
                    oPer = 1;
                }
                if (cPer > 100) { cPer = 100; }
                else if (year.closedpercentage > 0 && year.closedpercentage < 1) {
                    cPer = 1;
                }
                /*TODO get what question we are on and determine if we are to resumse or restart*/
                const openText = ( oPer != 100 ) ? "RESUME" : "DETAILS";
                const closeText = ( cPer != 100 ) ? "RESUME" : "DETAILS";

                if (year.useravailable == 1) {                    
                    return (
                        <TestTabletTableCard
                            className="tableCard"
                            useravailable={year.useravailable}
                            testYear={year.ProductYear}
                            openProgress={oPer > 0 ? openText : "BEGIN"}
                            closedProgress={cPer > 0 ? closeText : "BEGIN"}
                            openpercentage={oPer}
                            closedpercentage={cPer}
                        />
                    );
                } else {
                    return (
                        <TestTabletTableCard
                            className="disabledTableCard"
                            useravailable={year.useravailable}
                            testYear={year.ProductYear}
                            openProgress={year.openpercentage > 0 ? openText : "BEGIN"}
                            closedProgress={year.closedpercentage > 0 ? closeText : "BEGIN"}
                        />
                    );
                }
            });
        } else {
            {
                /*Clean and size this up correctly */
            }
            return (
                <div className="homeDeckCardDiv">
                    <Skeleton width={"8em"} height={"11em"} />
                </div>
            );
        }
    };

    createMarkup = props => {
        return { __html: props };
    };

    confirmCME = async () => {
        this.handleClose();

        return null;


        await this.props.confirmCME({
            mcid: this.props.auth_feedback.mcid,
            key: this.props.auth_feedback.key,
            programID: this.state.cmeProgram,
            tracking: this.state.tracking
        });

        let arr = this.state.cmeYears.slice();
        let i = arr.findIndex(item => item.programID === this.state.cmeProgram);

        arr[i].confirmed = 1;

        setLocalStorage('cmeYears', arr);

        await this.setState({ ...this.state, cmeConfirmed: this.state.cmeConfirmed++, cmeYears: arr });
    };

    homeLink = (data) => {
        return null;
        return this.props.history.push(data);
    }

    mapModalBody = () => {
        let d = new Date();
        let _y = d.getFullYear();
        let _year = Number(20 + this.state.cmeProgram.replace('SASP', ''));
        return (
            <div style={{
                backgroundColor: "#fff",
                border: "4px solid #00567a",
                borderRadius: "0px",
                padding: "8px 16px 16px",
                height: `calc(100vh - 0px)`,
                width: 'calc(100vw - 40px)',
                overflowY: 'auto',
                overflowX: 'hidden',
                outline: "none" 
            }}
            id='homeDIV'
            >
                <h3 id="simple-modal-title" className="margin-top-4 text-blue">
                    {this.state.cmeTitle}
                </h3>

                <div 
                    id="cme-modal-description" 
                    style={{fontSize: "1rem"}}
                    dangerouslySetInnerHTML={createMarkup(
                        this.state.cmeBody
                    )}
                />

                {this.state.cmeProgram === 'SASP21'
                    ? (
                        <div style={{
                            display:"flex",
                            flexDirection:"column",
                            justifyContent:"flex-start",
                            alignItems:"flex-start",
                            width:"100%",
                            margin: "8px 0"
                        }}>
                            <div className="width100 margin-bottom-16">
                                
                                <Link className="text-blue text-bold margin-bottom-8" onClick={() => remoteURL('https://University.auanet.org/sasp/resources/education_council_disclosures_2021.pdf')} >
                                    <Typography className="homeDividerText" style={{padding: "0 0 8px", fontSize:"0.8rem"}}>
                                        Education Council Disclosures
                                    </Typography>
                                    View Disclosures
                                </Link>

                                <Divider className="margin-top-8" />
                            </div>

                            <div className="width100 margin-bottom-16">
                                <Link className="text-blue text-bold margin-bottom-8" onClick={() => remoteURL('https://University.auanet.org/sasp/resources/coi_review_disclosures_2021.pdf')} >
                                    <Typography className="homeDividerText" style={{padding: "0 0 8px", fontSize:"0.8rem"}}>
                                        COI Review Work Group Disclosures
                                    </Typography>
                                    View Disclosures
                                </Link>

                                <Divider className="margin-top-8" />
                            </div>

                            <div className="width100 margin-bottom-16">
                                <Link className="text-blue text-bold margin-bottom-8" onClick={() => remoteURL('https://University.auanet.org/sasp/resources/abu_exam_committee_2021.pdf')} >
                                    <Typography className="homeDividerText" style={{padding: "0 0 8px", fontSize:"0.8rem"}}>
                                        ABU Examination Committee Disclosures
                                    </Typography>
                                    View Disclosures
                                </Link>

                                <Divider className="margin-top-8" />
                            </div>
                        </div>
                    ) : null
                }

                {this.state.cmeProgram === 'SASP22'
                    ? (
                        <div style={{
                            display:"flex",
                            flexDirection:"column",
                            justifyContent:"flex-start",
                            alignItems:"flex-start",
                            width:"100%",
                            margin: "8px 0"
                        }}>
                            <div className="width100 margin-bottom-16">
                                
                                <Link className="text-blue text-bold margin-bottom-8" onClick={() => remoteURL('https://University.auanet.org/sasp/resources/2022_SASP_CME_Disclosures.pdf')} >
                                    <Typography className="homeDividerText" style={{padding: "0 0 8px", fontSize:"0.8rem"}}>
                                        View Disclosures
                                    </Typography>
                                    
                                </Link>

                                <Divider className="margin-top-8" />
                            </div>
                        </div>
                    ) : null
                }

                <div className="margin-top-16">
                    <SaspButton 
                        onClick={this.confirmCME}
                        className="deregister_button"
                        color="secondaryBlue"
                        style={{float: "none !important"}}
                    >
                        Confirm SASP {_year}
                    </SaspButton> 
                </div>

                {_year === _y
                    ? (
                        <CopyrightWidget 
                            year={_year}
                            textAlign={'center'}
                            className="width100 margin-top-16 padding-top-8 padding-bottom-8 padding-left-16 padding-right-16"
                        />
                    )
                    : (
                        <CopyrightWidget 
                        begin={_year}
                        year={_y}
                        textAlign={'center'}
                        className="width100 margin-top-16 padding-top-8 padding-bottom-8 padding-left-16 padding-right-16"
                    />
                    )
                }
            </div>
        )
    }

    setBanner = () => {
        return (
            <>
                <>
                    {this.state.isDaily && this.state.hv
                        ? (
                            <DailyBannerCard />
                        ) : null
                    }
                </>
                <>
                    {this.state.newVersion && !this.state.hv 
                        ? (
                            <VersionBannerCard />
                        ) : null
                    }
                </>
            </>
        )
    }
   
    render() {
        try {
            if (!this.state.loading) {
                if ( isElectron || isMobileOnly || isTablet || isBrowser) {
                    let testing = isElectron;
                    let testClasses = "homeTableTestContainer";
                    const user = this.props.user_details;
                    const showQuizzes = typeof user.showQuizzes !== 'undefined' ? true : false;

                    if (isTablet || !testing) { testClasses += ' margin-top-24 padding-top-8'; }

                    try {
                        clearInterval(this.state.interval)
                    } catch (e) {
                    }

                    return (
                        <div className="sasp-home-page">  
                            {/* <div className="sasp-fab-container-vertical ">
                                <Fab
                                    size="small"
                                    className="margin-bottom-4"
                                    style={{background: "var(--aua-app-background-grad-linear-dark-green)", color: '#fff'}}
                                    aria-label="remove"
                                    onClick={() => this.resetData()}
                                    InDecks={''}
                                >
                                    <CachedIcon className="text-white" />
                                </Fab>
                            </div> */}

                            {this.state.message !== null
                                ? (
                                    <MessageBannerCard data={this.state.message} />
                                ) : (
                                    this.setBanner()
                                )
                            }

                            {/* <AILegalStatementCard in={hasLegal()} /> */}
                            
                            <div className="width100 height100-old" style={{paddingBottom: "72px"}}>
                                <div className="margin-bottom-8px">
                                    {/* <HomeUserInfo
                                        name={this.props.user_details.firstName ? this.props.user_details.firstName : 'Guest'}
                                        courses={this.props.user_details.courses ? this.props.user_details.courses.length : 0}
                                        transcripts={this.props.user_details.transcripts ? this.props.user_details.transcripts.length : 0}
                                        disclosures={this.props.user_details.disclosures ? this.props.user_details.disclosures.length : 0}
                                        reporting={this.props.user_details.reporting ? this.props.user_details.reporting : this.state._reporting}
                                        goTo={this.homeLink}
                                    /> */}

                                    <HomeUserInfo
                                        name="Your Ranking"
                                        reporting={this.state._reporting}
                                        goTo={this.homeLink}
                                    />
                                </div>

                                <div style={{ padding: "16px 0 0"}}>
                                    <Typography className="homeDividerText" >
                                        SASP CME Open Book Tests

                                        <div className="pull-right">
                                            <ModalIcon
                                                title='Open Book'
                                                icon='info'
                                                body={this.props.helperIcons.open}
                                                color='#fefefe'
                                                colorOverride='#009ACE'
                                                className="margin-left-16 pull-right"
                                                classes={`margin-left-16 pull-right margin-right-16`} 
                                                float='right'
                                        />    
                                        </div>
                                    </Typography>
                                    <Divider className="SASPTestsDivider" />
                                </div>

                                {this.state.saspyears !== null
                                    ? (
                                        <div className="homeDeckCardContainer">
                                            {this.mapYearWidgets({ data: this.state.saspyears, gamemode: 1 })}
                                        </div>
                                    ) : (
                                        <div className="homeDeckCardContainer">
                                            {this.mapLoading({name: 'Loading', deckname: 'CME Tests'})}
                                        </div>
                                    )
                                }

                                {this.state.premade.length > 0 && this.state.showPre
                                    ? (
                                        <>
                                            <div style={{ padding: "16px 0 0"}}>
                                                <Typography className="homeDividerText" >
                                                    Decks By Topic Area

                                                    <div className="pull-right">
                                                        <ModalIcon
                                                            title='Decks by Topic Area'
                                                            icon='info'
                                                            body={this.props.helperIcons.prebuilt}
                                                            color='#fefefe'
                                                            colorOverride='#009ACE'
                                                            className="margin-left-16 pull-right"
                                                            classes={`margin-left-16 pull-right margin-right-16`} 
                                                            float='right'
                                                        />
                                                    </div>    
                                                </Typography>
                                                <Divider className="SASPTestsDivider" />
                                            </div>

                                            <div className="homeDeckCardContainer">{this.mapPremadeDecks()}</div>
                                        </>
                                    ) : (
                                        <>
                                            <div style={{ padding: "16px 0 0"}}>
                                                <Typography className="homeDividerText" >Decks By Topic Area</Typography>
                                                <Divider className="SASPTestsDivider" />
                                            </div>

                                            <div className="homeDeckCardContainer">
                                                {this.mapLoading({name: 'Topics', deckname: 'Loading'})}
                                            </div>
                                        </>
                                    )
                                }

                                {this.state.quizzes !== null && (testerArr.includes(this.props.auth_feedback.mcid) || showQuizzes)
                                    ? (
                                        <>
                                            <div style={{ padding: "16px 0 0"}}>
                                                <Typography className="homeDividerText" >
                                                    Non-CME Open Book Quizzes
                                                    <div className="pull-right">
                                                        <ModalIcon
                                                            title='Quizzes'
                                                            icon='info'
                                                            body={this.props.helperIcons.quizzes}
                                                            color='#fefefe'
                                                            colorOverride='#009ACE'
                                                            className="margin-left-16 pull-right"
                                                            classes={`margin-left-16 pull-right margin-right-16`} 
                                                            float='right'
                                                        />
                                                    </div>
                                                </Typography>
                                                <Divider className="SASPTestsDivider" />
                                            </div>

                                            <div className="homeDeckCardContainer">
                                                {this.mapQuizzes({name: 'Coming Soon', deckname: 'Quizzes'}, this.state.quizzes, 9)}
                                            </div>
                                        </>
                                    ) : null
                                }

                                {this.state.quizzes !== null && (testerArr.includes(this.props.auth_feedback.mcid) || showQuizzes)
                                    ? (
                                        <>
                                            <div style={{ padding: "16px 0 0"}}>
                                                <Typography className="homeDividerText" >
                                                    Non-CME Closed Book Quizzes
                                                    <div className="pull-right">
                                                        <ModalIcon
                                                            title='Quizzes'
                                                            icon='info'
                                                            body={this.props.helperIcons.quizzes}
                                                            color='#fefefe'
                                                            colorOverride='#009ACE'
                                                            className="margin-left-16 pull-right"
                                                            classes={`margin-left-16 pull-right margin-right-16`} 
                                                            float='right'
                                                        />
                                                    </div>
                                                </Typography>
                                                <Divider className="SASPTestsDivider" />
                                            </div>

                                            <div className="homeDeckCardContainer">
                                                {this.mapQuizzes({name: 'Coming Soon', deckname: 'Quizzes'}, this.state.quizzes, 10)}
                                            </div>
                                        </>
                                    ) : null
                                }

                                {this.state.homeDecks
                                    ? (
                                        <>
                                            <div style={{ padding: "16px 0 0"}}>
                                                <Typography className="homeDividerText" >
                                                    My Decks

                                                    <div className="pull-right">
                                                        <ModalIcon
                                                            title='Custom Decks'
                                                            icon='info'
                                                            body={this.props.helperIcons.mydecks}
                                                            color='#fefefe'
                                                            colorOverride='#009ACE'
                                                            className="margin-left-16 pull-right"
                                                            classes={`margin-left-16 pull-right margin-right-16`} 
                                                            float='right'
                                                        />
                                                    </div>    
                                                </Typography>
                                                <Divider className="SASPTestsDivider" />
                                            </div>

                                            <div className="homeDeckCardContainer">
                                                <Link 
                                                    to={{ pathname: '/createDeckScreen'}}
                                                >
                                                    <div className="aua-circle-widget">
                                                        <div className="aua-circle-widget-icon  deck-icon">
                                                            <AddIcon style={{fontSize: "2em"}}/>
                                                        </div>
                                                        <div className="aua-circle-widget-text">Create Deck</div>
                                                    </div>
                                                </Link>

                                                {this.mapDecksWidgets()}
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div style={{ padding: "16px 0 0"}}>
                                                <Typography className="homeDividerText" >My Decks</Typography>
                                                <Divider className="SASPTestsDivider" />
                                            </div>

                                            <div className="homeDeckCardContainer">
                                                {this.mapLoading({name: 'Loading Decks', deckname: 'Custom Decks'})}
                                            </div>
                                        </>
                                    )
                                }

                                <div style={{ padding: "16px 0 0"}}>
                                    <Typography className="homeDividerText" >
                                        SASP CME Closed Book Tests

                                        <div className="pull-right">
                                            <ModalIcon
                                                title='Closed Book'
                                                icon='info'
                                                body={this.props.helperIcons.closed}
                                                color='#fefefe'
                                                colorOverride='#009ACE'
                                                className="margin-left-16 pull-right"
                                                classes={`margin-left-16 pull-right margin-right-16`} 
                                                float='right'
                                            />  
                                        </div>  
                                    </Typography>
                                    <Divider className="SASPTestsDivider" />
                                </div>

                                {this.state.saspyears !== null
                                    ? (
                                        <div className="homeDeckCardContainer">
                                            {this.mapYearWidgets({ data: this.state.saspyears, gamemode: 2 })}
                                        </div>
                                    ) : (
                                        <div className="homeDeckCardContainer">
                                            {this.mapLoading({name: 'Loading', deckname: 'CME Tests'})}
                                        </div>
                                    )
                                }

                                <div className="padding-left-16 padding-right-16">
                                    <CopyrightWidget 
                                        style={{width: "auto;"}}
                                        begin={2012}
                                        year={getThisYear()}
                                        textAlign={'center'}
                                        className="margin-top-8 padding-top-8 padding-bottom-24"
                                    />
                                </div>
                            </div>
                        </div> 
                    )
                } else {
                    return (
                        <LoadingCard 
                            text="Load Error..."
                            color="#00567a"
                        />
                    )
                }
            } else {
                return (
                    <LoadingCard textarray={this.state.loadingtext}/>
                )
            }
        } catch (e) {
            return <Redirect to={`/error`} />
        }
    }
}


const mapStateToProps = state => {
    const { auth_feedback, user_details, cme_confirmations, isDaily, program, saspyears, appreporting, residentprogram } = state.auth;
    const { headerText, iconOne, iconTwo } = state.style;
    const { deckList, flashCards, premade, quizzes, longquizzes, programquizzes } = state.decks;
    const { helperIcons } = state.device;
    return {
        headerText,
        iconOne,
        iconTwo,
        deckList,
        auth_feedback,
        user_details,
        cme_confirmations,
        isDaily,
        flashCards,
        premade,
        program,
        quizzes,
        longquizzes,
        programquizzes,
        saspyears,
        appreporting,
        residentprogram,
        helperIcons
    };
};

const HomeScreen = connect(mapStateToProps, { updateHeaderInfo, getDecks, confirmCME, getUserDetails, getDailyQuestion, updateRating, getFlashCards, getPremadeDecks, getSASPResidencyProgram, getQuizzes, getLongQuizzes, getProgramQuizzes, getSASPYears, getRanking, syncCMETest, simulateResponse, trackPage })(Home);

export { HomeScreen };
